import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import withScanner from '../../common/withScanner';
import withLotScanner from '../../common/withLotScanner';
import withProducts from '../../common/withProducts';
import withNotify from '../../common/withNotify';
import withGoBack from '../../common/withGoBack';
import Bugsnag from '../../helpers/bugsnag';
import withTableName from '../../common/withTableName';
import { findLot, findProduct } from '../../helpers/find-product';
import EnterProductNoManually from '../../components/Models/EnterProductNoManually';
import withOnline from '../../common/withOnline';
import Scanner from '../../components/commonComponents/Scanner/Scanner';

class ProductScan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productCount: 0,
      isSkipLot: false,
      picker: [],
      selectedIndex: 0,
      currentScan: {},
      productBarcode: '',
      onlineEngineLocation: 'https://cdn.jsdelivr.net/npm/scandit-sdk@5.11.1/build/',
      offlineEngineLocation: '/assets/js/scandit-sdk@5.11.1/build/',
      engineLocation: '',
      scanPaused: true,
    };
    this.enterProductNoManuallyModal = null;
  }

  componentDidMount() {
    try {
      this.enterProductNoManuallyModal = new window.bootstrap.Modal(window.$('#enterProductNoManuallyModal'));
      const {
        scanner, products, setProducts
      } = this.props;
      if (products[scanner.key] !== undefined) {
        this.setState({
          selectedIndex: scanner.key,
          currentScan: products[scanner.key]
        });
      }
      if (!products.some(({ ProductNo }) => ProductNo === '' || ProductNo === undefined) || products.length === 0) {
        products.push({
          CaseNo: null,
          RepCaseNo: null,
          ProductBarcode: null,
          LotBarcode: null,
          ScanDate: '',
          RepInventoryType: null,
          ScanOrder: null,
          ProductRep: null,
          DeviceID: null,
          Submitted: 0,
          Imported: 0,
          ProductEnterType: null,
          LotEnterType: null,
          ProductValid: true,
          BarcodeType: null,
          ScanError: null,
          AppGeneratedID: null,
          UnitPrice: null,
          ProductCaseNo: null,
          uploadedToAPI: false,
          ProductNo: '',
          ProductDescription: '',
          LotNo: null,
          InventoryType: null,
          isScanProduct: true,
          isScanLot: true,
          isOtherCharge: false
        });
        setProducts(products);
        const last = products[products.length - 1];
        this.setState({
          currentScan: last
        });
      }
      this._renderScanner();
      this._getProductLength();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  componentWillUnmount() {
    try {
      const { picker } = this.state;
      picker.destroy();
      /* if (isMobile) {
        if (Object.keys(picker).length > 0) {
          picker.destroy();
        }
      } */
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSkipLot = () => {
    try {
      const { setProducts, products } = this.props;
      const { currentScan } = this.state;
      if (Object.keys(currentScan).length > 0) {
        products.push({
          CaseNo: null,
          RepCaseNo: null,
          ProductBarcode: null,
          LotBarcode: null,
          ScanDate: '',
          RepInventoryType: null,
          ScanOrder: null,
          ProductRep: null,
          DeviceID: null,
          Submitted: 0,
          Imported: 0,
          ProductEnterType: null,
          LotEnterType: null,
          ProductValid: true,
          BarcodeType: null,
          ScanError: null,
          AppGeneratedID: null,
          UnitPrice: null,
          ProductCaseNo: null,
          uploadedToAPI: false,
          ProductNo: '',
          ProductDescription: '',
          LotNo: null,
          InventoryType: null,
          isScanProduct: true,
          isScanLot: true,
          isOtherCharge: false
        });
        setProducts(products);
        const last = products[products.length - 1];
        this.setState({
          currentScan: last,
          selectedIndex: products.length - 1,
          isSkipLot: true
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onScan = (data) => {
    try {
      const { scanner, setScanner } = this.props;
      const scanData = Object.assign(scanner, { data });
      setScanner(scanData);
      this._onFindProductAndLot(scanData);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getProductLength = async () => {
    try {
      /* const { params: { id }, tableName } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      this.setState({
        productCount: caseDetail.case_products.length
      }); */
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFindProductAndLot = async (scanner) => {
    try {
      const {
        products, notify, setProducts, setScanner
      } = this.props;
      const { currentScan, selectedIndex, productCount } = this.state;
      if (Object.keys(scanner).length > 0 && scanner.data !== undefined) {
        const productRes = await findProduct(scanner, scanner.data, products);
        const lotScanRes = await findLot(scanner, scanner.data, products);

        if (currentScan.ProductNo === '') {
          if (Object.keys(productRes).length > 0) {
            if (productRes.ProductNo === undefined) {
              this.setState({
                productBarcode: productRes.ProductBarcode
              });
              this.enterProductNoManuallyModal.show();
            }
          }
        }

        if (!Object.keys(lotScanRes).length > 0) {
          if (productRes.type === 'UNKNOWN') {
            notify({ type: 'error', message: 'The scanned barcode is invalid. Scan again or enter product number manually.', time: 3 });
            return;
          }
        }

        if (currentScan.ProductNo === '') {
          if (Object.keys(productRes).length > 0) {
            if (lotScanRes.ScanType === 'lot') {
              notify({ type: 'error', message: 'A Lot barcode was scanned. You must scan a Product barcode.', time: 3 });
              return;
            }
            if (productRes.ScanType === 'product') {
              currentScan.ProductNo = productRes.ProductNo === undefined ? '' : productRes.ProductNo;
              currentScan.ProductDescription = productRes.ProductDescription;
              currentScan.ProductBarcode = productRes.ProductBarcode === undefined
                ? null : productRes.ProductBarcode;
              currentScan.BarcodeType = productRes.BarcodeType;
              currentScan.ProductValid = productRes.ProductValid;
              currentScan.ProductEnterType = productRes.ProductEnterType;
              currentScan.LotNo = productRes.LotNo === undefined ? null : productRes.LotNo;
              currentScan.LotEnterType = productRes.LotEnterType === undefined
                ? null : productRes.LotEnterType;
              currentScan.LotBarcode = productRes.LotBarcode === undefined
                ? null : productRes.LotBarcode;
              currentScan.isScanProduct = false;

              // console.log(currentScan);
              this.setState({
                currentScan,
                isSkipLot: currentScan.LotNo === '',
                productCount: productCount + 1
              }, () => {
                products[selectedIndex]
                  = Object.assign(products[selectedIndex], this.state.currentScan);
                setProducts(products);
                setScanner({ key: scanner.key, scanType: 'product' });
              });
            }
          } else {
            notify({ type: 'error', message: 'A Lot barcode was scanned, You must scan a Product barcode.', time: 3 });
          }
        } else if (currentScan.LotNo === null) {
          if (productRes.ScanType === 'product') {
            notify({ type: 'error', message: 'A Product barcode was scanned. You must scan a Lot barcode.', time: 3 });
            return;
          }
          if (Object.keys(lotScanRes).length > 0) {
            if (lotScanRes.ScanType === 'lot') {
              currentScan.LotNo = lotScanRes.LotNo;
              currentScan.LotEnterType = lotScanRes.LotEnterType;
              currentScan.LotBarcode = lotScanRes.LotBarcode;
              this.setState({
                currentScan
              }, () => {
                products[selectedIndex]
                  = Object.assign(products[selectedIndex], this.state.currentScan);
                setProducts(products);
              });
            }
          } else if (scanner.scanType === 'lot' && currentScan.ProductNo !== '') {
            notify({ type: 'error', message: 'A Product barcode was scanned. You must scan a Lot barcode.', time: 3 });
          } else {
            notify({ type: 'error', message: 'The scanned barcode is invalid. Scan again or enter product number manually.', time: 3 });
          }
        }

        if (Object.keys(currentScan).length > 0) {
          if (currentScan.ProductNo !== '' && currentScan.LotNo !== null) {
            // console.log(currentScan);
            products.push({
              CaseNo: null,
              RepCaseNo: null,
              ProductBarcode: null,
              LotBarcode: null,
              ScanDate: '',
              RepInventoryType: null,
              ScanOrder: null,
              ProductRep: null,
              DeviceID: null,
              Submitted: 0,
              Imported: 0,
              ProductEnterType: null,
              LotEnterType: null,
              ProductValid: true,
              BarcodeType: null,
              ScanError: null,
              AppGeneratedID: null,
              UnitPrice: null,
              ProductCaseNo: null,
              uploadedToAPI: false,
              ProductNo: '',
              ProductDescription: '',
              LotNo: null,
              InventoryType: null,
              isScanProduct: true,
              isScanLot: true,
              isOtherCharge: false
            });
            setProducts(products);
            const last = products[products.length - 1];
            this.setState({
              currentScan: last,
              selectedIndex: products.length - 1,
              isSkipLot: true
            });
          }
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProductScanDone = () => {
    try {
      const { params: { id }, products, setProducts } = this.props;
      if (products.length > 0) {
        const removeBlankProduct = products.filter((item) => (item.ProductNo !== '' || item.RepInventoryType !== null));
        setProducts(removeBlankProduct);
      }
      // this._onGoBack();
      /* const { picker } = this.state;
      picker.destroy(); */
      browserHistory.push(`/manage-case/${id}/products/add`);
      // setScanner({});
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onEnterProductNoManually = () => {
    const { params: { id }, products, setProducts } = this.props;
    const { selectedIndex, productBarcode } = this.state;
    try {
      products[selectedIndex].ProductBarcode = productBarcode;
      setProducts(products);
      browserHistory.push(`/manage-case/${id}/products/add`);
      this.enterProductNoManuallyModal.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { innerHeight, innerWidth } = window;
    const {
      productCount, isSkipLot, scanPaused
    } = this.state;
    const { scanner, params: { id } } = this.props;
    return (
      <div className="outer">
        <div className="inner">
          <Scanner
            paused={scanPaused}
            onScan={this._onScan}
            centerInterestPoint={false}
            setPaused={(value) => this.setState({ scanPaused: value })}
            style={{ maxWidth: innerWidth, maxHeight: innerHeight }}
          />
          <section className="sets-footer-section fixed-bottom fixedBottom">
            <div className="container">
              <div className="button-block">
                <div className="row gx-2">
                  <div className="col-12 text-center">
                    <p className="mb-2">Products: {productCount}</p>
                    <button type="button" className="btn btn-sm btn-theme-alt btn-theme-outline-alt me-3" onClick={this._onProductScanDone}>Done</button>&nbsp;
                    <button
                      type="button"
                      className={`btn btn-lg btn-theme-alt btn-theme-outline-alt w-25 ${!scanPaused ? 'active' : ''}`}
                      onClick={() => this.setState({ scanPaused: false })}
                    >Scan
                    </button>&nbsp;
                    <button
                      type="button"
                      disabled={(scanner.scanType === 'lot') || (isSkipLot)}
                      className="btn btn-sm btn-theme-alt btn-theme-outline-alt ms-3"
                      onClick={this._onSkipLot}
                    >Skip Lot
                    </button>&nbsp;
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <EnterProductNoManually id={id} onOK={this._onEnterProductNoManually} />
      </div>
    );
  }
}

export default withOnline(withGoBack(
  withNotify(withProducts(withTableName(withLotScanner(withScanner(ProductScan)))))
));
